import { miniAppShareConfig } from "@/util/wxApi"
import { deleteUrlParam } from "@/pages/ThemePage/utils/common"

export default {
  methods: {
    // 获取当前地址[需去除distinctID]
    getCurrentURLPath() {
      return deleteUrlParam('distinctID')
    },
    wxMiniAppShareInit () {
      miniAppShareConfig({
        title: '海马体照相馆',
        url: this.getCurrentURLPath(),
      }, this.$sensors)
    }
  },
  beforeMount() {
    this.wxMiniAppShareInit()
  }
}
